import { render, staticRenderFns } from "./properties-block-table-cell.vue?vue&type=template&id=f9f7c3a8&scoped=true"
import script from "./properties-block-table-cell.vue?vue&type=script&lang=js"
export * from "./properties-block-table-cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f7c3a8",
  null
  
)

export default component.exports